exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "nav[data-v-61a7b2ff]{margin:40px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-61a7b2ff&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 11
// module chunks = 0